/**
 * Subscription and tier-related constants
 */

// Plan names
export const PLAN_NAME_FREE = 'Free';

// Lead generation limits
export const FREE_TIER_LEAD_LIMIT = 20;
export const FREE_TIER_LIMIT = FREE_TIER_LEAD_LIMIT; // Alias for backward compatibility
export const MAX_LEADS_PER_REQUEST = 1000;

// Helper to get max allowed leads based on subscription
export const getMaxLeadsAllowed = (isFreeTier: boolean): number => {
  return isFreeTier ? FREE_TIER_LEAD_LIMIT : MAX_LEADS_PER_REQUEST;
};

// Error messages
export const FREE_TIER_LEAD_LIMIT_MESSAGE = `Free plan users can generate up to ${FREE_TIER_LEAD_LIMIT} results at a time`;
export const FREE_TIER_ADD_LIMIT_MESSAGE = `Free plan users can add up to ${FREE_TIER_LEAD_LIMIT} results at a time. Upgrade to add more.`;
export const MAX_LEADS_EXCEEDED_MESSAGE = `Maximum ${MAX_LEADS_PER_REQUEST} leads allowed - please reduce the number`;
